import "./TaskItem.css";

function TaskItem({ task, onToggle, onDelete }) {
  return (
    <>
      <div>
        <input
          type="checkbox"
          checked={task.completed}
          onChange={() => onToggle(task.id)}
          className="checkboxStyle"
        />

        <span
          style={{
            fontSize: "28px",
            textDecoration: task.completed ? "line-through" : "none",
            fontFamily: "initial",
          }}
        >
          {task.text}
        </span>

        <button
          style={{ cursor: "pointer", fontSize: "20px", border: "none" }}
          onClick={() => onDelete(task.id)}
        >
          ❌
        </button>
      </div>
    </>
  );
}

export default TaskItem;
